var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.175V6.825q0-.424.3-.713a.98.98 0 0 1 .962-.25q.138.038.263.113l8.15 5.175q.225.15.337.375a1.05 1.05 0 0 1 0 .95.97.97 0 0 1-.337.375l-8.15 5.175a1.04 1.04 0 0 1-.525.15.98.98 0 0 1-.7-.288.95.95 0 0 1-.3-.712"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };